import { useMemo } from 'react';
/**
 * Traverse down to find nearest component descendant.
 */
export function findNearestDescendant(type, component) {
    // look in current depth first before checking next depth
    const children = (component === null || component === void 0 ? void 0 : component.children) || [];
    const target = children.find(child => child.type === type);
    if (target) {
        return target;
    }
    for (const component of children) {
        const target = findNearestDescendant(type, component);
        if (target) {
            return target;
        }
    }
}
/**
 * Traverse down to find nearest component descendant.
 */
export function useFindNearestDescendant(type, component) {
    return useMemo(() => {
        return findNearestDescendant(type, component);
    }, [component, type]);
}
//# sourceMappingURL=useFindNearestDescendant.js.map